import { RcClasses } from '../../../../foundation';
export var RcCheckboxClasses = RcClasses(['root', 'disabled', 'checked'], 'RcCheckbox');
